import {fuzzyMatchRegex} from '@wandb/weave/common/util/fuzzyMatch';
import {Button, ButtonSizes, ButtonVariants} from '@wandb/weave/components';
import {TextField} from '@wandb/weave/components/Form/TextField';
import React, {useMemo, useState} from 'react';

import {DD_PRIVACY_ALLOW} from '../../../../../../util/datadog/privacy';
import {useShouldShowMediaBoundingBoxConfigResetAtLevel} from '../../../hooks';
import {useMediaSettingsContext} from '../../contexts/MediaSettingsContextProvider';
import {BoundingBoxesForMediaKey} from './BoundingBoxesForMediaKey';
import {ConfidenceSlider} from './ConfidenceSlider';

export const BoundingBoxes = () => {
  const {allBoxes, sliderRanges, unsetConfigField, settingsLevel, panelRef} =
    useMediaSettingsContext();
  const isBoundingBoxConfigSet =
    useShouldShowMediaBoundingBoxConfigResetAtLevel(settingsLevel, panelRef);
  const [boxSearchQuery, setBoxSearchQuery] = useState('');
  const boxQueryRegex = useMemo(
    () => fuzzyMatchRegex(boxSearchQuery),
    [boxSearchQuery]
  );

  return (
    <div className="flex flex-col">
      <div
        className="mb-8 flex justify-between"
        data-dd-privacy={DD_PRIVACY_ALLOW}>
        <TextField
          dataTest="bounding-box-search-input"
          value={boxSearchQuery}
          onChange={setBoxSearchQuery}
          icon="search"
          placeholder="Search"
        />
        {isBoundingBoxConfigSet && (
          <Button
            aria-label="Reset to parent"
            icon="randomize-reset-reload"
            onClick={() => {
              unsetConfigField('boundingBoxConfig');
            }}
            size={ButtonSizes.Medium}
            tooltip="Reset to parent"
            variant={ButtonVariants.Ghost}
          />
        )}
      </div>
      {sliderRanges &&
        Object.keys(sliderRanges).map(key => (
          <ConfidenceSlider sliderKey={key} key={key} />
        ))}
      {Object.keys(allBoxes).map(mediaKey => (
        <BoundingBoxesForMediaKey
          mediaKey={mediaKey}
          key={mediaKey}
          boxQueryRegex={boxQueryRegex}
        />
      ))}
    </div>
  );
};
